import { useMemo } from 'react';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import {
  setCurrentTab,
  setColumnVisibility,
  setProvidersTableFilters,
  setClearProvidersTableFilters,
} from '@Modal/reducers/providers/table/providerTableSlice';

// Types
import { StoreInterface } from 'src/app/types';
import { FilterItemType } from '@Modal/reducers/types';

export const useProvidersTable = () => {
  const dispatch = useDispatch();

  const {
    columnVisibility,
    columnVisibilityOptions,
    selectedFilters,
    providersTableFilters,
    currentTab,
  } = useSelector((state: StoreInterface) => state?.providersTable);

  const providersListFilters = useMemo(() => {
    const columnVisibilityStrArr = Array.from(Object.values(columnVisibility)).map((filt) => filt);
    return columnVisibilityStrArr as string[];
  }, [columnVisibility]);

  const handleApplyColumnVisibility = (column: string[]) => {
    const newVisibleColumns = [...providersListFilters, ...column];
    if (providersListFilters.filter((col) => column.includes(col)).length > 0) {
      const filteredNewVisibleColumns = providersListFilters.filter((col) => col !== column[0]);
      dispatch(setColumnVisibility(filteredNewVisibleColumns));
    } else {
      dispatch(setColumnVisibility(newVisibleColumns));
    }
  };

  const visiblityCustomizable = useMemo(
    () => ({
      value: columnVisibility,
      options: columnVisibilityOptions,
      apply: (value: string[]) => handleApplyColumnVisibility(value),
    }),
    [columnVisibility, columnVisibilityOptions]
  );

  const handleFilterSelect = (filter: FilterItemType) => {
    dispatch(setProvidersTableFilters(filter));
  };

  const handleClearProvidersTableFilters = () => {
    dispatch(setClearProvidersTableFilters());
  };

  const handleTabChange = (arg: number) => {
    dispatch(setCurrentTab(arg));
  };

  return {
    // State
    currentTab,
    selectedFilters,
    columnVisibility,
    providersListFilters,
    visiblityCustomizable,
    columnVisibilityOptions,
    providersTableFilters,
    // Actions
    setCurrentTab,
    setProvidersTableFilters,
    setClearProvidersTableFilters,
    // Handlers
    handleTabChange,
    handleFilterSelect,
    handleApplyColumnVisibility,
    handleClearProvidersTableFilters,
  };
};
